//--------------------------------------------------------------------
// Shared State 
//--------------------------------------------------------------------

// Getters

// Notification Getters
export const GET_NOTIFICATION_ID = 'shared/GET_NOTIFICATION_ID'
export const GET_PURPOSE_ID = 'shared/GET_PURPOSE_ID'
export const GET_PURPOSE_OTHERS = 'shared/GET_PURPOSE_OTHERS'
export const GET_MAP = 'shared/GET_MAP'
export const GET_WAYPOINTS = 'shared/GET_WAYPOINTS'
export const GET_PURPOSES = 'shared/GET_PURPOSES'
export const GET_AGENCIES = 'shared/GET_AGENCIES'
export const GET_REQUEST_TYPES = 'shared/GET_REQUEST_TYPES'
export const GET_EMERGENCY_NOTIFICATION = 'shared/GET_EMERGENCY_NOTIFICATION'
export const GET_STATUSES = 'shared/GET_STATUSES'
export const GET_EHOC_REF = 'shared/GET_EHOC_REF'
export const GET_NV_FOR = 'shared/GET_NV_FOR'
export const GET_NV_NUMBER = 'shared/GET_NV_NUMBER'
export const GET_REQUEST_TYPE_ID = 'shared/GET_REQUEST_TYPE_ID'
export const GET_REQUESTED_BY = 'shared/GET_REQUESTED_BY'
export const GET_LAST_UPDATED_BY = 'shared/GET_LAST_UPDATED_BY'
export const GET_NOTES = 'shared/GET_NOTES'
export const GET_STATUS_ID = 'shared/GET_STATUS_ID'
export const GET_ATTACHMENTS = 'shared/GET_ATTACHMENTS'
export const GET_DETAILS_NOTIFICATION = 'shared/GET_DETAILS_NOTIFICATION'
export const GET_ORG_ANONYMOUS = 'shared/GET_ORG_ANONYMOUS'
export const GET_SUBMITTED_ID = 'shared/GET_SUBMITTED_ID'
// export const GET_DEPARTURE_DATE = 'shared/GET_DEPARTURE_DATE'
// export const GET_ARRIVAL_DATE = 'shared/GET_ARRIVAL_DATE'

// User Getters
export const GET_USER_ID = 'shared/GET_USER_ID'
export const GET_USERNAME = 'shared/GET_USERNAME'
export const GET_USER_FIRSTNAME = 'shared/GET_USER_FIRSTNAME'
export const GET_USER_LASTNAME = 'shared/GET_USER_LASTNAME'
export const GET_USER_TOKEN = 'shared/GET_USER_TOKEN'
export const GET_USER_PERMISSION = 'shared/GET_USER_PERMISSION'
export const GET_USER_AGENCY_ID = 'shared/GET_USER_AGENCY_ID'
export const GET_USER_AGENCY_NAME = 'shared/GET_USER_AGENCY_NAME'
export const GET_AGENCY_OTHERS = 'shared/GET_AGENCY_OTHERS'
export const GET_MODE = 'shared/GET_MODE'
export const GET_MODIFIED = 'shared/GET_MODIFIED'
export const GET_NEW_NOTIFICATION = 'shared/GET_NEW_NOTIFICATION'
export const GET_MAP_MODIFIED = 'shared/GET_MAP_MODIFIED'
export const GET_MAP_INDEX = 'shared/GET_MAP_INDEX'
export const GET_VIEW_MOFA = 'shared/GET_VIEW_MOFA'
export const GET_AIR_USAGE = 'shared/GET_AIR_USAGE'
export const GET_AIR_CLEARANCE = 'shared/GET_AIR_CLEARANCE'
export const GET_AIR_REQUEST = 'shared/GET_AIR_REQUEST'
export const GET_AIR_OPERATOR = 'shared/GET_AIR_OPERATOR'
export const GET_NSL_FACILITY_TYPE = 'shared/GET_NSL_FACILITY_TYPE'
export const GET_NSL_SITE_TYPE = 'shared/GET_NSL_SITE_TYPE'
export const GET_START_DATE = 'shared/GET_START_DATE'
export const GET_TOTAL_ROWS = 'shared/GET_TOTAL_ROWS'

// Mutations
// Common
export const MUTATE_RESET_STATE = 'shared/MUTATE_RESET_STATE'
export const MUTATE_RESET_TOKEN = 'shared/MUTATE_RESET_TOKEN'
export const MUTATE_PURPOSES = 'shared/MUTATE_PURPOSES'
export const MUTATE_AGENCIES = 'shared/MUTATE_AGENCIES'
export const MUTATE_REQUEST_TYPES = 'shared/MUTATE_REQUEST_TYPES'
export const MUTATE_EMERGENCY_NOTIFICATION = 'shared/MUTATE_EMERGENCY_NOTIFICATION'
export const MUTATE_STATUSES = 'shared/MUTATE_STATUSES'
export const MUTATE_ATTACHMENTS = 'shared/MUTATE_ATTACHMENTS'

// Users
export const MUTATE_USER_ID = 'shared/MUTATE_USER_ID'
export const MUTATE_USERNAME = 'shared/MUTATE_USERNAME'
export const MUTATE_USER_FIRSTNAME = 'shared/MUTATE_USER_FIRSTNAME'
export const MUTATE_USER_LASTNAME = 'shared/MUTATE_USER_LASTNAME'
export const MUTATE_USER_TOKEN = 'shared/MUTATE_USER_TOKEN'
export const MUTATE_USER_PERMISSION = 'shared/MUTATE_USER_PERMISSION'
export const MUTATE_USER_AGENCY_ID = 'shared/MUTATE_USER_AGENCY_ID'
export const MUTATE_USER_AGENCY_NAME = 'shared/MUTATE_USER_AGENCY_NAME'
export const MUTATE_AGENCY_OTHERS = 'shared/MUTATE_AGENCY_OTHERS'

// Notification
export const MUTATE_NOTIFICATION_ID = 'shared/MUTATE_NOTIFICATION_ID'
export const MUTATE_PURPOSE_ID = 'shared/MUTATE_PURPOSE_ID'
export const MUTATE_PURPOSE_OTHERS = 'shared/MUTATE_PURPOSE_OTHERS'
export const MUTATE_DETAILS_NOTIFICATION = 'shared/MUTATE_DETAILS_NOTIFICATION'
export const MUTATE_REQUEST_TYPE_ID = 'shared/MUTATE_REQUEST_TYPE_ID'
export const MUTATE_REQUESTED_DATE = 'shared/MUTATE_REQUESTED_DATE'
export const MUTATE_MAP = 'shared/MUTATE_MAP'
export const MUTATE_WAYPOINTS = 'shared/MUTATE_WAYPOINTS'
export const MUTATE_EHOC_REF = 'shared/MUTATE_EHOC_REF'
export const MUTATE_CENTCOM_REF = 'shared/MUTATE_CENTCOM_REF'
export const MUTATE_NV_NUMBER = 'shared/MUTATE_NV_NUMBER'
export const MUTATE_NV_FOR = 'shared/MUTATE_NV_FOR'
export const MUTATE_REQUESTED_BY = 'shared/MUTATE_REQUESTED_BY'
export const MUTATE_LAST_UPDATED_BY = 'shared/MUTATE_LAST_UPDATED_BY'
export const MUTATE_NOTES = 'shared/MUTATE_NOTES'
export const MUTATE_STATUS_ID = 'shared/MUTATE_STATUS_ID'
export const MUTATE_MODE = 'shared/MUTATE_MODE'
export const MUTATE_MODIFIED = 'shared/MUTATE_MODIFIED'
export const MUTATE_NEW_NOTIFICATION = 'shared/MUTATE_NEW_NOTIFICATION'
export const MUTATE_MAP_MODIFIED = 'shared/MUTATE_MAP_MODIFIED'
export const MUTATE_MAP_INDEX = 'shared/MUTATE_MAP_INDEX'
export const MUTATE_VIEW_MOFA = 'shared/MUTATE_VIEW_MOFA'
export const MUTATE_AIR_USAGE = 'shared/MUTATE_AIR_USAGE'
export const MUTATE_AIR_CLEARANCE = 'shared/MUTATE_AIR_CLEARANCE'
export const MUTATE_AIR_REQUEST = 'shared/MUTATE_AIR_REQUEST'
export const MUTATE_AIR_OPERATOR = 'shared/MUTATE_AIR_OPERATOR'
export const MUTATE_NSL_FACILITY_TYPE = 'shared/MUTATE_NSL_FACILITY_TYPE'
export const MUTATE_NSL_SITE_TYPE = 'shared/MUTATE_NSL_SITE_TYPE'
export const MUTATE_START_DATE = 'shared/MUTATE_START_DATE'
export const MUTATE_END_DATE = 'shared/MUTATE_END_DATE'
export const MUTATE_TOTAL_ROWS = 'shared/MUTATE_TOTAL_ROWS'
export const MUTATE_ORG_ANONYMOUS = 'shared/MUTATE_ORG_ANONYMOUS'
export const MUTATE_SUBMITTED_ID = 'shared/MUTATE_SUBMITTED_ID'


// export const MUTATE_DEPARTURE_DATE = 'shared/MUTATE_DEPARTURE_DATE'
// export const MUTATE_ARRIVAL_DATE = 'shared/MUTATE_ARRIVAL_DATE'


// Actions
export const ACTION_FIND_USER_BY_USERNAME= 'shared/ACTION_FIND_USER_BY_USERNAME'
export const ACTION_FIND_NOTIFICATION_BY_ID = 'shared/ACTION_FIND_NOTIFICATION_BY_ID'
export const ACTION_FIND_MAP = 'shared/ACTION_FIND_MAP'
export const ACTION_FIND_WAYPOINTS = 'shared/ACTION_FIND_WAYPOINTS'
export const ACTION_FIND_PURPOSES = 'shared/ACTION_FIND_PURPOSES'
export const ACTION_FIND_AGENCIES = 'shared/ACTION_FIND_AGENCIES'
export const ACTION_FIND_REQUEST_TYPES = 'shared/ACTION_FIND_REQUEST_TYPES'
export const ACTION_FIND_EMERGENCY_NOTIFICATION = 'shared/ACTION_FIND_EMERGENCY_NOTIFICATION'
export const ACTION_FIND_STATUSES = 'shared/ACTION_FIND_STATUSES'
export const ACTION_FIND_STATUS_BY_ID = 'shared/ACTION_FIND_STATUS_BY_ID'
export const ACTION_AUTH_USER = 'shared/ACTION_AUTH_USER'
export const ACTION_FIND_AIR_USAGE = 'shared/ACTION_FIND_AIR_USAGE'
export const ACTION_FIND_NSL_FACILITY_TYPE = 'shared/ACTION_FIND_NSL_FACILITY_TYPE'
export const ACTION_FIND_NSL_SITE_TYPE = 'shared/ACTION_FIND_NSL_SITE_TYPE'
export const ACTION_ADD_AGENCY = 'shared/ACTION_ADD_AGENCY'
export const ACTION_DELETE_ATTACHMENT = 'shared/ACTION_DELETE_ATTACHMENT'
export const ACTION_TOTAL_ROWS = 'shared/ACTION_TOTAL_ROWS'
export const ACTION_TOTAL_ROWS_AGENCY = 'shared/ACTION_TOTAL_ROWS_AGENCY'


//--------------------------------------------------------------------
// Modules - USER
//--------------------------------------------------------------------

// Actions
export const ACTION_FIND_USER_BY_ID = 'user/ACTION_FIND_USER_BY_ID'
export const ACTION_FIND_USER_BY_AGENCY_ID = 'user/ACTION_FIND_USER_BY_AGENCY_ID'
export const ACTION_ADD_USER = 'user/ACTION_ADD_USER'
export const ACTION_UPDATE_USER = 'user/ACTION_UPDATE_USER'

// Getters
export const GET_USER = 'user/GET_USER'
export const GET_USER_LIST = 'user/GET_USER_LIST'

// Mutations
export const MUTATE_USER = 'user/MUTATE_USER'
export const MUTATE_USER_LIST = 'user/MUTATE_USER_LIST'

//--------------------------------------------------------------------
// Modules - Land Movement
//--------------------------------------------------------------------

// Getters
export const GET_CONVOYS = 'land_movement/GET_CONVOYS'
export const GET_PARTICIPANTS = 'land_movement/GET_PARTICIPANTS'
export const GET_VEHICLES = 'land_movement/GET_VEHICLES'
export const GET_TRUCKS = 'land_movement/GET_TRUCKS'
export const GET_PHOTOS = 'land_movement/GET_PHOTOS'

// Mutations
export const MUTATE_CONVOYS = 'land_movement/MUTATE_CONVOYS'
export const MUTATE_PARTICIPANTS= 'land_movement/MUTATE_PARTICIPANTS'
export const MUTATE_VEHICLES= 'land_movement/MUTATE_VEHICLES'
export const MUTATE_TRUCKS= 'land_movement/MUTATE_TRUCKS'
export const MUTATE_PHOTOS = 'land_movement/MUTATE_PHOTOS'


// Actions
export const ACTION_ADD_NOTIFICATION = 'land_movement/ACTION_ADD_NOTIFICATION'
export const ACTION_ADD_WAYPOINTS =  'land_movement/ACTION_ADD_WAYPOINTS'
export const ACTION_ADD_CONVOYS = 'land_movement/ACTION_ADD_CONVOYS'
export const ACTION_ADD_PARTICIPANTS = 'land_movement/ACTION_ADD_PARTICIPANTS'
export const ACTION_ADD_VEHICLES = 'land_movement/ACTION_ADD_VEHICLES'
export const ACTION_ADD_TRUCKS = 'land_movement/ACTION_ADD_TRUCKS'
export const ACTION_ADD_PHOTOS = 'land_movement/ACTION_ADD_PHOTOS'
export const ACTION_FIND_PHOTOS = 'land_movement/ACTION_FIND_PHOTOS'

//--------------------------------------------------------------------
// Modules - Temp Venue
//--------------------------------------------------------------------
// Getters
export const GET_VENUES = 'temp_venue/GET_VENUES'

// Mutations
export const MUTATE_VENUES = 'temp_venue/MUTATE_VENUES'

// Actions
export const ACTION_ADD_VENUES = 'temp_venue/ACTION_ADD_VENUES'
export const ACTION_UPDATE_VENUES = 'temp_venue/ACTION_UPDATE_VENUES'

//--------------------------------------------------------------------
// Modules - Sea
//--------------------------------------------------------------------
// Getters
 export const GET_SEA = 'sea/GET_SEA'
 export const GET_MEMBERS = 'sea/GET_MEMBERS'

// Mutations
export const MUTATE_SEA = 'sea/MUTATE_SEA'
export const MUTATE_MEMBERS = 'sea/MUTATE_MEMBERS'

// Actions
export const ACTION_ADD_SEA = 'sea/ACTION_ADD_SEA'
export const ACTION_UPDATE_SEA = 'sea/ACTION_UPDATE_SEA'

//--------------------------------------------------------------------
// Modules - Notification
//--------------------------------------------------------------------

// Getters
export const GET_NOTIFICATION_LIST = 'notification/GET_NOTIFICATION_LIST'
export const GET_USER_NOTIFICATION_LIST = 'notification/GET_USER_NOTIFICATION_LIST'
export const GET_DASHBOARD_STATISTICS = 'notification/GET_DASHBOARD_STATISTICS'
export const GET_TRACKING_SHEET = 'notification/GET_TRACKING_SHEET'

// Mutations
export const MUTATE_NOTIFICATION_LIST = 'notification/MUTATE_NOTIFICATION_LIST'
export const MUTATE_USER_NOTIFICATION_LIST = 'notification/MUTATE_USER_NOTIFICATION_LIST'
export const MUTATE_DASHBOARD_STATISTICS = 'notification/MUTATE_DASHBOARD_STATISTICS'
export const MUTATE_TRACKING_SHEET = 'notification/MUTATE_TRACKING_SHEET'

// Actions
export const ACTION_ADMIN_NOTIFICATION_LIST = 'notification/ACTION_ADMIN_NOTIFICATION_LIST'
export const ACTION_USER_NOTIFICATION_LIST = 'notification/ACTION_USER_NOTIFICATION_LIST'
export const ACTION_UPDATE_NOTIFICATION_STATUS = 'notification/ACTION_UPDATE_NOTIFICATION_STATUS'
export const ACTION_UPDATE_NOTIFICATION = 'notification/ACTION_UPDATE_NOTIFICATION'
export const ACTION_UPDATE_NOTIFICATION_REQUEST = 'notification/ACTION_UPDATE_NOTIFICATION_REQUEST'
export const ACTION_DELETE_NOTIFICATION = 'notification/ACTION_DELETE_NOTIFICATION'
export const ACTION_DASHBOARD_STATISTICS = 'notification/ACTION_DASHBOARD_STATISTICS'
export const ACTION_TRACKING_SHEET = 'notification/ACTION_TRACKING_SHEET'

//--------------------------------------------------------------------
// Modules - AIR
//--------------------------------------------------------------------
// Getters
export const GET_AIR = 'air/GET_AIR'

// Mutations
export const MUTATE_AIR = 'air/MUTATE_AIR'

// Actions
export const ACTION_ADD_AIR = 'air/ACTION_ADD_AIR'
export const ACTION_UPDATE_AIR = 'air/ACTION_UPDATE_AIR'
export const ACTION_FIND_AIR = 'air/ACTION_FIND_AIR'

//--------------------------------------------------------------------
// Modules - No Strike List
//--------------------------------------------------------------------
// Getters
export const GET_NSL = 'nsl/GET_NSL'

// Mutations
export const MUTATE_NSL = 'nsl/MUTATE_NSL'

// Actions
export const ACTION_ADD_NSL = 'nsl/ACTION_ADD_NSL'
export const ACTION_UPDATE_NSL = 'nsl/ACTION_UPDATE_NSL'
export const ACTION_FIND_NSL = 'nsl/ACTION_FIND_NSL'

//--------------------------------------------------------------------
// Modules - MOFA LAND
//--------------------------------------------------------------------
// Getters
export const GET_MOFA_LAND = 'mofa/GET_MOFA_LAND'
export const GET_MOFA_CENTCOM = 'mofa/GET_MOFA_CENTCOM'
export const GET_MOFA_TEMP = 'mofa/GET_MOFA_TEMP'
export const GET_MOFA_AIR = 'mofa/GET_MOFA_AIR'
export const GET_MOFA_NSL = 'mofa/GET_MOFA_NSL'
export const GET_MOFA_SEA = 'mofa/GET_MOFA_SEA'

// Mutations
export const MUTATE_MOFA = 'mofa/MUTATE_MOFA'
export const MUTATE_MOFA_CENTCOM = 'mofa/MUTATE_MOFA_CENTCOM'

// Actions
export const ACTION_ADD_MOFA = 'mofa/ACTION_ADD_MOFA'
export const ACTION_UPDATE_MOFA = 'mofa/ACTION_UPDATE_MOFA'
export const ACTION_FIND_MOFA = 'mofa/ACTION_FIND_MOFA'
export const ACTION_ADD_MOFA_CENTCOM = 'mofa/ACTION_ADD_MOFA_CENTCOM'
export const ACTION_UPDATE_MOFA_CENTCOM = 'mofa/ACTION_UPDATE_MOFA_CENTCOM'
export const ACTION_FIND_MOFA_CENTCOM = 'mofa/ACTION_FIND_MOFA_CENTCOM'

//export const ACTION_ADD_MOFA_AIR = 'mofa/ACTION_ADD_MOFA_AIR'
// export const ACTION_UPDATE_MOFA_AIR = 'mofa/ACTION_UPDATE_MOFA_AIR'

// export const ACTION_ADD_MOFA_SEA = 'mofa/ACTION_ADD_MOFA_SEA'
// export const ACTION_UPDATE_MOFA_SEA = 'mofa/ACTION_UPDATE_MOFA_SEA'

// export const ACTION_ADD_MOFA_NSL = 'mofa/ACTION_ADD_MOFA_NSL'
// export const ACTION_UPDATE_MOFA_NSL = 'mofa/ACTION_UPDATE_MOFA_NSL'

// export const ACTION_ADD_MOFA_TEMP = 'mofa/ACTION_ADD_MOFA_TEMP'
// export const ACTION_UPDATE_MOFA_TEMP = 'mofa/ACTION_UPDATE_MOFA_TEMP'







// WEBPACK FOOTER //
// ./src/store/types.js